export default {"src":"/_next/static/media/trophy.4ef35f16.svg","height":184,"width":184};